/**
 * Returns the title for the delivery based on the delivery mode.
 * @param {string} deliveryMode - The delivery mode.
 * @returns {string} - The title for the delivery.
 */
export const getOrderTypeFromDeliveryMode = (deliveryMode: string): string => {
  if (deliveryMode === 'Pickup') {
    return 'Pickup'
  } else if (deliveryMode === 'WarePickup') {
    return 'Seed pickup'
  } else if (deliveryMode === 'Card') {
    return 'Farmlands Card'
  } else if (deliveryMode === '') {
    return 'In Store Purchase'
  } else {
    return 'Delivery'
  }
}

export default getOrderTypeFromDeliveryMode
